import { Box, Button, Dialog, Typography } from '@cere/cere-design-system';

interface Props {
  open: boolean;
  onAllow: () => void;
  onDeny: () => void;
}

// One-time consent prompt shown the first time a widget asks the vault to
// sign with the connected wallet. The sign bytes are opaque (JCS-canonical
// Vault payloads), so the copy states the capability being granted rather
// than the specific payload. Approving persists a global grant — see
// WidgetIframeModal's revoke control to undo it.
export function WidgetSignConsentDialog({ open, onAllow, onDeny }: Props) {
  return (
    <Dialog
      open={open}
      maxWidth="sm"
      title="Allow widgets to sign with your wallet?"
      onClose={onDeny}
      customActions={
        <>
          <Button variant="tertiary" onClick={onDeny}>Not now</Button>
          <Button variant="primary" onClick={onAllow}>Allow</Button>
        </>
      }
    >
      <Box sx={{ py: 1 }}>
        <Typography variant="body2" color="text.secondary">
          This widget wants to sign data with your connected wallet. Allowing
          lets installed widgets sign Vault requests on your behalf without
          asking again. Only allow this if you trust the widgets you open. You
          can revoke this permission from any widget at any time.
        </Typography>
      </Box>
    </Dialog>
  );
}
